<template>
    <div class="register">
        <h1 class="brdBtn topTitle">商品登録</h1>
           <div class="container">
              <div class="infomation">
               <h2 class="majorItems" :class="{isOpen:mainIsShow, isClose:!mainIsShow}" @click="mainIsShow = !mainIsShow;" >商品の情報</h2>
                <div v-if="mainIsShow" >
                    <div class="itemname">
                        <h3 id="itemTitle" class="itemLable">商品名<span class="mandatory">必須</span></h3>
                        
                        <div class='validErrMsg' v-for="err in $v.postItem.ITEM_TITLE.errMsg" :key="err">{{ err }}</div>
                      
                        
                        <input class="input" id="" type="text" placeholder="商品名、型番など" 
                            v-model="postItem.ITEM_TITLE" @input="valid($v.postItem.ITEM_TITLE, '商品名')">
                        <h3 id="itemTitle" class="itemLable">商品名2</h3>
                        <span class="minText">※商品名2を設定すると、出品回数に応じて商品タイトルを入れ替えます。</span>
                        <div class='validErrMsg' v-for="err in $v.postItem.ITEM_TITLE2.errMsg" :key="err">{{ err }}</div>
                        <input class="input" id="" type="text" placeholder="商品名、型番など" 
                            v-model="postItem.ITEM_TITLE2" @input="valid($v.postItem.ITEM_TITLE2, '商品名2')">
                        <h3 id="itemTitle" class="itemLable">商品名3</h3>
                        <span class="minText">※商品名3を設定すると、出品回数に応じて商品タイトルを入れ替えます。</span>
                        <div class='validErrMsg' v-for="err in $v.postItem.ITEM_TITLE3.errMsg" :key="err">{{ err }}</div>
                        <input class="input" id="" type="text" placeholder="商品名、型番など" 
                            v-model="postItem.ITEM_TITLE3" @input="valid($v.postItem.ITEM_TITLE3, '商品名3')">
                    </div>
                    <div class="brdBtm">
                        <h3 class="itemLable">画像</h3>
                        <div class="paddingBtm30">
                            <div v-if="tmpFiles.length>0">
                                <span class="minText">※チェックをつけた画像は出品毎に画像表示を入れ替えます。</span><br>
                                <!-- <div class="imagePrevBox" > -->
                                <draggable class="imagePrevBox" :options="options" @end="onEnd" v-model="tmpFiles">
                                    <div class="childImgBox" v-for="(tmpFile,index) in tmpFiles" :key="index">
                                        
                                        <img class="itemImg" :src="tmpFile">
                                        <input type="checkbox" :disabled="tmpRoopImg.length >=3 && tmpRoopImg.indexOf(String(index + 1)) == -1" v-model="tmpRoopImg" :id="index + 1" :value="String(index + 1)">
                                        <label class="checkbox03" :for="index + 1" ></label>
                                        <span class="delBtn" @click="fileDelete(index)"></span>
                                        <span class="drive" @click="getDriveImg(false)"></span>
                                    </div>
                                    <div class="childImgBox setImgBox" v-if="tmpFiles.length < 10" >
                                        <!-- <button class="btn" @click="getDriveImg(false)">GoogleDrive<br>から選択</button> -->
                                        <input class="files" type="file" title @change="onChange">
                                        <span class="minText centerText">あと{{10 - tmpFiles.length}}枚<br>登録できます</span>
                                    </div>
                                </draggable>
                                <!-- </div> -->
                            </div>
                            <div class="image-input" v-if="tmpFiles.length==0">
                                <div
                                    class="image-input__field"
                                    @dragover.prevent="onDrag('over')"
                                >
                                <input class="files" type="file" title multiple @change="onChange">
                                <p class="imgText">ドラッグ&ドロップ</P>
                                <label class="imgBtn">
                                    ファイルを<br>選択
                                    <input class="none" type="file" multiple @change="onChange">
                                </label>
                                <!-- <label class="imgBtn" @click="getDriveImg">GoogleDrive<br>から選択</label> -->
                                </div>
                            </div>
                        </div>

                        <div id="overlay" v-show="isDriveErr">
                            <div class="driveModal">
                                <div class="swal2-popup swal2-modal swal2-show" style="display: grid;" >
                                    <p>フォルダ内の画像が多すぎます。不要な画像を削除してください</p>
                                    <div class="imagePrevBox">
                                        <div class="childImgBox" v-for="(item, index) in tmpGogoleImg" :key="index" >
                                            <img class="itemImg" :src="item">
                                            <span class="delBtn" @click="driveFileDelete(index -1)"></span>
                                        </div>
                                    </div>
                                    <button class="swal2-confirm swal2-styled" @click="setDriveInFile" :disabled="(tmpGogoleImg.length + tmpFiles.length)  > 10">Close</button>
                                </div>
                            </div>
                        </div>

                    </div>
                    
                    <div class="brdBtm">
                        <h3 id="itemContent" class="itemLable">商品説明<span class="mandatory">必須</span></h3>
                        
                        <div class='validErrMsg' v-for="(err) in $v.postItem.ITEM_CONTENT.errMsg" :key="err">{{ err }}</div>
                        
                        <textarea  rows="10" cols="100" class="txtarea" placeholder="商品の特徴や、使用感、魅力など"
                            v-model="postItem.ITEM_CONTENT" @input="valid($v.postItem.ITEM_CONTENT, '商品説明')"
                        ></textarea>
                    </div>

                        <div class="brdBtm">
                        <h3  id="status" class="itemLable">商品状態<span class="mandatory">必須</span></h3>
                        <div class='validErrMsg' v-for="(err) in $v.tmpStatus.errMsg" :key="err">{{ err }}</div>
                       
                        <select class="sltBox" v-model="tmpStatus" @change="valid($v.tmpStatus, '商品状態')">
                            <option value="" disabled selected hidden>選択してください</option>
                            <option v-for="item in statusList" :value="item.CODE_ID" :key="item.ITEM_ID">
                                {{ item.CODE_NAME }}
                            </option>
                        </select>
                    </div>
                        <div class="brdBtm">
                            <h3 id="itemPrice" class="itemLable">商品販売価格<span class="mandatory">必須</span></h3>
                            
                            <div class='validErrMsg' v-for="(err) in $v.postItem.ITEM_PRICE.errMsg" :key="err">{{ err }}</div>
                            
                            <input class="input-2" type="number" v-model="postItem.ITEM_PRICE" @input="valid($v.postItem.ITEM_PRICE, '商品販売価格')">
                            <p class="unit">円</p>
                        </div>

                        <div class="brdBtm">
                            <h3 id="purchasePrice" class="itemLable">商品仕入価格</h3>
                            <div class='validErrMsg' v-for="(err) in $v.postItem.PURCHASE_PRICE.errMsg" :key="err">{{ err }}</div>

                            <input class="input-2" type="number" v-model="postItem.PURCHASE_PRICE" @input="valid($v.postItem.PURCHASE_PRICE, '商品仕入価格')">
                            <p class="unit">円</p>
                        </div>
                        <div class="brdBtm">
                            <h3 id="quanity" class="itemLable">在庫数<span class="mandatory">必須</span></h3>
                            
                            <div class='validErrMsg' v-for="(err) in $v.postItem.STOCK_QUANITY.errMsg" :key="err">{{ err }}</div>
                            
                            <input class="input-2" type="number" v-model="postItem.STOCK_QUANITY" @input="valid($v.postItem.STOCK_QUANITY, '在庫数')">
                            <p class="unit">個</p>
                        </div>
                        <div class="brdBtm">
                            <h3 id="discountPrice" class="itemLable">値引額</h3>
                            <div class='validErrMsg' v-for="(err) in $v.postItem.DISCOUNT_PRICE.errMsg" :key="err">{{ err }}</div>
                            <div class="minText">※未入力の場合、販売開始から値引をいたしません。</div>
                            <input class="input-2" type="number" v-model="postItem.DISCOUNT_PRICE" @input="valid($v.postItem.DISCOUNT_PRICE, '値引額')">
                            <p class="unit">円</p>
                        </div>
                        <div id="discountNum" class="brdBtm" v-show="postItem.DISCOUNT_PRICE != 0">
                            <h3 class="itemLable">値引回数</h3>
                            <div class='validErrMsg' v-for="(err) in $v.postItem.DISCOUNT_NUM.errMsg" :key="err">{{ err }}</div>
                            <div class="minText">※値引額を入力した場合は必須項目です。</div>
                            <input class="input-2" type="number" v-model="postItem.DISCOUNT_NUM" @input="valid($v.postItem.DISCOUNT_NUM, '値引回数')">
                            <p class="unit">回</p>
                        </div>
                        <div>
                            <h3 class="itemLable">出品停止日</h3>
                            <span class="minText">出品日時から選択日後に出品停止します。</span>
                            <select class="sltBox" v-model="postItem.SUSPEND_DAY">
                                <option :value="1">1日後</option>
                                <option :value="2">2日後</option>
                                <option :value="3">3日後</option>
                                <option :value="4">4日後</option>
                            </select>
                        </div>
                        <div class="brdBtm">
                            <h3 id="shipLoad" class="itemLable">いいねがついた商品に自動コメントをする<span class="mandatory">必須</span></h3>
                            
                            <!-- <div class='validErrMsg' v-for="(err) in $v.tmpShipload.errMsg" :key="err">{{ err }}</div> -->
                         
                            <span v-for="n in 2" :key="n">
                                <input type="radio" v-model="postItem.COMMENT" :id="n+'_suspendList'" :value="n">
                                <label class="radioLabel" :for="n+'_suspendList'">{{ n==1?'コメントする':'コメントしない' }}</label>
                            </span>
                        </div>
                        <div class="brdBtm">
                            <h3 id="shipLoad" class="itemLable">送料負担<span class="mandatory">必須</span></h3>
                            
                            <div class='validErrMsg' v-for="(err) in $v.tmpShipload.errMsg" :key="err">{{ err }}</div>
                         
                            <span v-for="item in shiploadList" :key="item.CODE_ID">
                                <input type="radio" v-model="tmpShipload" :id="item.CODE_ID+'_shiploadList'" :value="item.CODE_ID" @change="valid($v.tmpShipload, '送料負担')">
                                <label class="radioLabel" :for="item.CODE_ID+'_shiploadList'">{{ item.CODE_NAME }}</label>
                            </span>
                        </div>
                        <div class="brdBtm">
                            <h3 id="shipSorce" class="itemLable">発送元<span class="mandatory">必須</span></h3>
                           
                            <div class='validErrMsg' v-for="(err) in $v.tmpShipsource.errMsg" :key="err">{{ err }}</div>
                         
                            <select class="sltBox" v-model="tmpShipsource" @change="valid($v.tmpShipsource, '発送元')">
                                <option value="" disabled selected hidden>選択してください</option>
                                <option v-for="item in shipsorceList" :value="item.CODE_ID" :key="item.CODE_ID">
                                    {{ item.CODE_NAME }}
                                </option>
                            </select>
                        </div>
                        <div class="brdBtm">
                            <h3 id="shipSchedule" class="itemLable">発送日数<span class="mandatory">必須</span></h3>
                         
                            <div class='validErrMsg' v-for="(err) in $v.tmpShipSchedule.errMsg" :key="err">{{ err }}</div>
                        
                            <select class="sltBox" v-model="tmpShipSchedule" @change="valid($v.tmpShipSchedule, '発送日数')">
                                <option value="" disabled selected hidden>選択してください</option>
                                <option v-for="item in shipScheduleList" :value="item.CODE_ID" :key="item.CODE_ID">
                                    {{ item.CODE_NAME }}
                                </option>
                            </select>
                        </div>
                        <div class="brdBtm">
                            
                            <h3 id="shipSchedule" class="itemLable">備考</h3>
                            <span class="minText">出品には影響ありません。ご自身のメモ用に記載ください</span>
                            <textarea  rows="10" cols="100" class="txtarea" placeholder="備考"
                                v-model="postItem.MEMO"
                            ></textarea>
                        </div>
                </div>
                    
                <div class="RakumaItem">
                    <h2 class="majorItems" :class="{isOpen:rakumaIsShow, isClose:!rakumaIsShow}" @click="rakumaIsShow = !rakumaIsShow;" >ラクマ独自設定</h2>
                    <div v-if="rakumaIsShow" >
                        <div class="brdBtm">
                            <h3 id="rcategory" class="itemLable">カテゴリ<span class="mandatory">必須</span></h3>
                            <div class="s" v-for="(child, index) in rCategoryList.child" :key="index">
                              
                                <div class='validErrMsg' v-for="(err) in $v.rCategoryList.child.$each[index].parentId.errMsg" :key="err">{{ err }}</div>
                                <select class="sltBox" v-model="rCategoryList.child[index].parentId" @change="
                                    RakumaSizeCheck(rCategoryList.child[index].parentId, rCategoryList.child[index]),getChildCategory( 'rCategoryList',index), valid($v.rCategoryList.child.$each[index].parentId, 'カテゴリ')">
                                    <option value="" disabled selected hidden>選択してください</option>
                                    <option v-for="item in rCategoryList.child[index].parent" :value="item.CODE_ID" :key="item.CODE_ID">
                                        {{ item.CODE_NAME }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="brdBtm">
                            <h3 class="itemLable">ブランド名</h3>
                            <input class="input" type="text" placeholder="メーカー名" v-model="rakuma_post_item.R_BRAND">
                        </div>


                        <div class="brdBtm" v-show="RSizeList.length > 0">
                            <h3 id="rSize" class="itemLable">サイズ<span class="mandatory">必須</span></h3>
                            <div class='validErrMsg' v-for="(err) in $v.rakuma_post_item.R_SIZE.errMsg" :key="err">{{ err }}</div>
                            <select class="sltBox" v-model="rakuma_post_item.R_SIZE" @change="valid($v.rakuma_post_item.R_SIZE, 'サイズ')">
                                <option value="" disabled selected hidden>選択してください</option>
                                <option v-for="item in RSizeList" :value="item.CODE_ID" :key="item.CODE_ID">
                                    {{ item.CODE_NAME }}
                                </option>
                            </select>
                        </div>

                        <div class="brdBtm">
                            <h3 id="rShipMethod" class="itemLable">配送方法<span class="mandatory">必須</span></h3>
                        
                            <div class='validErrMsg' v-for="(err) in $v.rakuma_post_item.R_SHIPMETHOD.errMsg" :key="err">{{ err }}</div>
                       
                            <select class="sltBox" v-model="rakuma_post_item.R_SHIPMETHOD" @change="valid($v.rakuma_post_item.R_SHIPMETHOD, '配送方法')">
                                <option value="" disabled selected hidden>選択してください</option>
                                <option v-for="item in RShipMethodList" :value="item.CODE_ID" :key="item.CODE_ID">
                                    {{ item.CODE_NAME }}
                                </option>
                            </select>
                        </div>
                        <div class="brdBtm">
                            <h3 class="itemLable">ラクマ購入申請</h3>
                       
                            <select class="sltBox" v-model="rakuma_post_item.R_REQUEST_REQUIRED" @change="valid($v.postItem.R_REQUEST_REQUIRED, 'ラクマ購入申請')">
                                <option value="" disabled selected hidden>選択してください</option>
                                <option v-for="item in RequestRequiredList" :value="item.CODE_ID" :key="item.CODE_ID">
                                    {{ item.CODE_NAME }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="none">
                    <input type="text" v-model="tmp">
                </div>
                <div class="btnBox">
                    <button class="btn repage" @click="returnPage">戻る</button>
                    <button class="btn submit" v-show="ITEM_ID != 0" @click="post(true)" >コピー</button>
                    <button class="btn submit" @click="post(false)" >登録</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    @import "../style/register.scss";
</style>
<script>
import {code_repository} from '@/Repositories/m002_r_code_repository.js'
import {category_repository} from '@/Repositories/m001_r_category_repository.js'
import {itemRepository} from '@/Repositories/itemRepository.js'
import {item_detail_repository} from '@/Repositories/u002_r_item_detail_repository.js'

import check from '@/common/commonCheck';
import { required, maxLength, between, minValue, helpers} from "vuelidate/lib/validators";
import axios from 'axios';
import draggable from 'vuedraggable'
var gasUrl = "https://script.google.com/macros/s/AKfycbyOcPBQiZtl3yGMo1iMmeCTgtblLg1Kg3sf7foUC0xAW2L3Zhg/exec";
export default {
    components: { draggable },
  data() {
        return {
            check:check,
            options: {
                  animation: 200
              },
            /******************
            　表示・非表示フラグ
            ******************/
            mainIsShow:true,
            // mercariIsShow:false,
            rakumaIsShow:false,
            // yahooIsShow:false,
            // yPremierIsShow:false,
            isDriveErr:false,
            /******************
            　カテゴリリスト
            ******************/
            baseCategories:null,
            mCategoryList:{
               parentId:'',
               parent:[],
               child:[{parentId:''}]
           },
            rCategoryList:{
               parentId:'',
               parent:[],
               child:[{parentId:''}]
           },
        //     yCategoryList:{
        //        parentId:'',
        //        parent:[],
        //        child:[{parentId:''}]
        //    },
            /******************
            　コードリスト
            　（共通）
            ******************/
            baseCode:null,
            statusList:null,
            shiploadList:null,
            shipsorceList:null,
            shipScheduleList:null,
            /******************
            　コードリスト
            　（ラクマ独自）
            ******************/
            RSizeList:[],
            RSizeListBase:[],
            RShipMethodList:null,
            RShipsorceList:null,
            RequestRequiredList:null,
            /******************
            　一時選択値格納
            ******************/
            tmp:'',
            tmpStatus:'',
            tmpShipload:'',
            tmpShipsource:'',
            tmpShipSchedule:'',
            tmpRoopImg:[],
            tmpFiles:[],
            tmpGogoleImg:[],
            tmpYOptions:[],
            ITEM_ID:0,
            /******************
            　サーバサイド連携値
            ******************/
            postItem:{
                ITEM_TITLE:'',
                ITEM_TITLE2:'',
                ITEM_TITLE3:'',
                ITEM_CONTENT:'',
                ITEM_IMG1:'',
                ITEM_IMG2:'',
                ITEM_IMG3:'',
                ITEM_IMG4:'',
                ITEM_IMG5:'',
                ITEM_IMG6:'',
                ITEM_IMG7:'',
                ITEM_IMG8:'',
                ITEM_IMG9:'',
                ITEM_IMG10:'',
                ROOP_IMG:'',
                ITEM_PRICE:'0',
                PURCHASE_PRICE:'0',
                STOCK_QUANITY:'0',
                DISCOUNT_PRICE:0,
                DISCOUNT_NUM:0,
                SUSPEND_DAY:4,
                MEMO:null,
                // Y_STATUS:'',
                // Y_CATEGORY:'',
                // Y_MAKER:'',
                // Y_SERIES:'',
                // Y_SIZE:'',
                // Y_SIZE2:'',
                // Y_QUANTITY:1,
                // Y_SHIPSOURCE:'',
                // Y_SHIPLOAD:'',
                // Y_SHIPMETHOD1:'',
                // Y_SHIPMETHOD2:'',
                // Y_SHIPMETHOD3:'',
                // Y_SHIPMETHOD4:'',
                // Y_SHIPMETHOD5:'',
                // Y_SHIPMETHOD6:'',
                // Y_SHIPMETHOD7:'',
                // Y_SHIPMETHOD8:'',
                // Y_SHIPMETHOD9:'',
                // Y_SHIPMETHOD10:'',
                // Y_SHIPMETHODOTHER1:'',
                // Y_SHIPMETHODOTHER2:'',
                // Y_SHIPMETHODOTHER3:'',
                // Y_SHIPMETHODOTHER4:'',
                // Y_SHIPMETHODOTHER5:'',
                // Y_SHIPMETHODOTHER6:'',
                // Y_SHIPMETHODOTHER7:'',
                // Y_SHIPMETHODOTHER8:'',
                // Y_SHIPMETHODOTHER9:'',
                // Y_SHIPMETHODOTHER10:'',
                // Y_SHIPSCHEDULE:'',
                // Y_SALESMODE:'buynow',
                // Y_STARTPRICE:0,
                // Y_ENDDAY:'',
                // Y_ENDTIME:'',
                // Y_NUMRESUBMIT:'',
                // Y_AUTOPRICEDOWN:'',
                // Y_CATEGORYORDER:'',
                // Y_CPAAMOUNT:'',
                // Y_OPTIONS:[],
                // M_CATEGORY:'',
                // M_BRAND:'',
                // M_SIZE:'',
                // M_SHIPLOAD:'',
                // M_SHIPMETHOD:'',
                // M_SHIPSOURCE:'',
                // M_SHIPSCHEDULE:'',
                // M_STATUS:'',
            },
            rakuma_post_item:{
                R_CATEGORY:'',
                R_BRAND:'',
                R_SIZE:'',
                R_SHIPLOAD:'',
                R_SHIPMETHOD:'',
                R_SHIPSCHEDULE:'',
                R_SHIPSOURCE:'',
                R_REQUEST_REQUIRED:0,
                R_STATUS:''
            }
        };
    },

    methods:{
        onEnd(e){
            this.tmpRoopImg.sort()
            var oldIndex = e.oldDraggableIndex + 1;
            var newindex = e.newIndex + 1;
            var index = this.tmpRoopImg.indexOf(String(oldIndex));
            if(index != -1){
                this.tmpRoopImg[index] = String(newindex);
            }
            for(var i=0; i<this.tmpRoopImg.length; i++){
                if(i == index) continue;
                if(newindex <= this.tmpRoopImg[i] &&oldIndex > this.tmpRoopImg[i]  ) {
                    var id = Number(this.tmpRoopImg[i]) + 1;
                    this.tmpRoopImg[i] = String(id);
                }
            }

            for(var i=0; i<this.tmpRoopImg.length; i++){
                if(i == index) continue;
                if(newindex >= this.tmpRoopImg[i] &&oldIndex < this.tmpRoopImg[i]  ) {
                    var id = Number(this.tmpRoopImg[i]) - 1;
                    this.tmpRoopImg[i] = String(id);
                }
            }
        },
        RakumaSizeCheck(str, tmp){
            let vm = this;
            console.log(tmp);
            // vm.postItem.R_SIZE = "";
            vm.RSizeList = [];
            var sizeGrp = tmp.parent.filter(x=> x.CODE_ID == str);
            if(sizeGrp.length == 1){
                vm.RSizeList = vm.RSizeListBase.filter(x=> x.PARENT_ID == sizeGrp[0].SIZE_GROUP);
            }
            
            // for(var i=1; i<=8;i++ ){
            //     var c = eval(`vm.RSizeList${i}[0].PARENT_ID.split(",");`)
            //     if(c.indexOf(str) != -1){
            //         vm.RSizeList = eval(`vm.RSizeList${i}`);
            //     }
            // }
        },
        
        resizeImage(base64image) {
            const MIN_SIZE = 1000;
           return new Promise(async function(resolve,reject){
                 var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                var image = new Image();
                image.crossOrigin = "Anonymous";
                image.onload = function(event){
                var dstWidth, dstHeight;
                if(this.width <= MIN_SIZE &&  this.height<= MIN_SIZE){
                    dstWidth = this.width;
                    dstHeight = this.height;
                }else{
                    if (this.width > this.height) {
                        dstWidth = MIN_SIZE;
                        dstHeight = this.height * MIN_SIZE / this.width;
                    } else{
                        dstHeight = MIN_SIZE;
                        dstWidth = this.width * MIN_SIZE / this.height;
                    }
                }
                canvas.width = dstWidth;
                canvas.height = dstHeight;
                ctx.drawImage(this, 0, 0, this.width, this.height, 0, 0, dstWidth, dstHeight);
                var dataURI = canvas.toDataURL('image/jpeg');
                resolve(dataURI);
            };
            image.src = base64image;

        })
        },
        GetCode(codeType){
            let vm = this;
            var rtnItem =  vm.baseCode.filter((item)=> {
                return item.CODE_TYPE == codeType;
            });
            return rtnItem.sort( (a, b)=> {
                return a.CODE_ID - b.CODE_ID
            });
        },
        GetCategories(parentId){
            let vm = this;
            var rtnItem =  vm.baseCategories.filter((item)=> {
                return  item.PARENT_ID == parentId;
            });
            return rtnItem.sort( (a, b)=> {
                return a.CODE_ID - b.CODE_ID
            });
        },
        getChildCategory( valName, index){
            let vm = this;
            var tmp = {}
            tmp.parent = vm.GetCategories(eval(`vm.${valName}.child[${index}].parentId`));
            tmp.child = [];
            tmp.parentId = '';
            eval(`vm.${valName}.child.splice(${index} + 1);`)
            if(tmp.parent.length > 0) eval(`vm.${valName}.child.push(tmp);`);
            
        },


        onDrag(type) {
            this.isDragOver = type === "over";
        },
        onChange(event) {
            const files = event.target.files;
            if(files.length === 0) return;
            var tmpFiles = [];

            if(files.length > 10){
                this.ngAlert("画像は最大10枚までです。<br>11枚目以降は無視されます。")
            }

            for(var i=0; i< files.length; i++){
                if (files[i].type.match(/image/)) {
                    tmpFiles.push(files[i]);
                }
            }
            if(tmpFiles.length == 0) return;

            this.readImage(tmpFiles);
        },
        readImage(files) {
            for(var i=0; i< files.length; i++){
                if(i >= 10 ) return;
                let reader = new FileReader();
                reader.onload = this.loadImage;
                reader.readAsDataURL(files[i]);
            }
        },
        loadImage(e) {
            let image = new Image();
            image.src = e.target.result;
            this.tmpFiles.push(image.src);
        },
        /**
         * 表示している画像を削除します。
         * @param {number}} index 配列Index
         */
        fileDelete(index){
            this.tmpFiles.splice(index, 1);
            this.tmpRoopImg.sort()
            var arrIndex = this.tmpRoopImg.indexOf(index +1);
            
            if(arrIndex != -1)  
                this.tmpRoopImg.splice(arrIndex, 1);
            
            for(var i=0; i<this.tmpRoopImg.length; i++){
                if(this.tmpRoopImg[i] > index+1) this.tmpRoopImg[i] = (this.tmpRoopImg[i] -1).toString();
            }
            this.tmpRoopImg = this.tmpRoopImg.filter((element, index) => this.tmpRoopImg.indexOf(element) == index);
        },
        /**
         * GoogleDriveの画像からBase64を取得します。
         * @param {boolean} isMulti 複数取得可否
         */
        async getDriveImg(){
            
            var inputText = `<h4>フォルダの共有リンクを入力</h4><span class="minText">※共有設定は必ず、<br>【リンクを知っている全員（閲覧者）】<br>に設定してください。</span><label>共有リンク:<input id="swal-input1" class="swal2-input" placeholder="共有リンク"></label>`;
            const {value: formValues} = await this.$swal.fire({
                title: 'GoogleDriveから画像設定',
                html: inputText,
                focusConfirm: false,
                preConfirm: () => {
                    return document.getElementById('swal-input1').value;
                }
            })
            if (formValues) {
                
                var url = formValues;
                if(!url) return;
                this.driveImgToBase64(url)
            }   
        },
        /**
         * GoogleDriveへGetリクエストを投げます
         * @param {string}} url GoogleDrive画像URL
         */
        driveImgToBase64(url){
            let vm =this;
            var api = `${gasUrl}?imgUrl=${url}`;
            axios.get(api)
            .then(res=>{
                vm.tmpGogoleImg = res.data.base64;
                
                if(vm.tmpGogoleImg.length > 10){
                    this.isDriveErr = true;
                }else
                    this.tmpFiles = imgList
                
            }).catch(err=>{
                console.log(err);
            })
        },
        driveFileDelete(index){
            this.tmpGogoleImg.splice(index + 1, 1);
        },
        setDriveInFile(){
            let vm= this;
            vm.isDriveErr = false;
            vm.tmpFiles = vm.tmpFiles.concat(vm.tmpGogoleImg);
        },
        /**
         * 遷移元へ戻ります
         */
        returnPage(){
            let vm = this;
            vm.$router.back();
        },
        /**
         * サーバサイドへポスト送信
         */
        async post(isCopy){
            let vm = this;
            vm.mainIsShow=true;
            vm.rakumaIsShow=true;
            if(!vm.validAll()){
                console.log('aaa');
                vm.tmp = 'tmp';
                vm.tmp = '';
                return;
            }

            //統一項目を各々のEntityに詰めなおす
            vm.rakuma_post_item.R_SHIPSOURCE = vm.tmpShipsource;
            vm.rakuma_post_item.R_SHIPSCHEDULE = vm.tmpShipSchedule;
            vm.rakuma_post_item.R_SHIPLOAD = vm.tmpShipload;
            vm.rakuma_post_item.R_STATUS = vm.tmpStatus;
            vm.setCategory();
            vm.rakuma_post_item.R_SIZE_NAME = vm.RSizeList.find(x=> x.CODE_ID == vm.rakuma_post_item.R_SIZE).CODE_NAME;
            await vm.setBase64();
            vm.postItem.ROOP_IMG = vm.tmpRoopImg.sort().join(',');
            if(isCopy) vm.postItem.ITEM_ID = null;

            itemRepository.methods.register(vm.postItem)
            .then(res=>{
                console.log(res.data);
                vm.rakuma_post_item.ITEM_ID = res.data.ITEM_ID;
                item_detail_repository.upd(vm.rakuma_post_item).then(r=>{
                    this.$swal({
                        title: "登録が完了しました",
                        icon: "success",
                    }).then(()=>{
                        vm.$router.push(`/itemList/${vm.$route.params.pageNum}`);
                    })
                })                
            }).catch(err=>{
                console.log(err);
            })
        },
        /**
         * 単体バリデーションチェックを実行し、エラーメッセージを設定します
         * @param {object} v validationオブジェクト
         * @param {stirng} name バリデーションエラーメッセージに表示する項目名
         * @param {stirng} regexType 正規表現種別
         */
        valid(v, name, regexType){
            check.checkStr(v, name, regexType);
        },
        /**
         * 全てのバリデーションチェックを実行し、エラーメッセージを設定します
         */
        validAll(){
            let vm = this;
            var isError = false;
            try{
                if(!check.checkStr(vm.$v.postItem.ITEM_TITLE, '商品名')) throw 'itemTitle';
                if(!check.checkStr(vm.$v.postItem.ITEM_CONTENT, '商品説明'))  throw 'itemContent';

                if(!check.checkStr(vm.$v.postItem.ITEM_TITLE, '商品名')) throw 'itemTitle';
                if(!check.checkStr(vm.$v.tmpStatus, '商品状態')) throw 'status';
                if(!check.checkStr(vm.$v.postItem.ITEM_PRICE, '商品販売価格')) throw 'itemPrice';
                if(!check.checkStr(vm.$v.postItem.PURCHASE_PRICE, '商品仕入価格')) throw 'purchasePrice';
                if(!check.checkStr(vm.$v.postItem.STOCK_QUANITY, '在庫数')) throw 'quanity';
                if(!check.checkStr(vm.$v.postItem.DISCOUNT_PRICE, '値引額')) throw 'discountPrice';
                if(!check.checkStr(vm.$v.postItem.DISCOUNT_NUM, '値引回数')) throw 'discountNum';
                
                if(!check.checkStr(vm.$v.tmpShipload, '送料負担')) throw 'shipLoad';
                if(!check.checkStr(vm.$v.tmpShipsource, '発送元')) throw 'shipSorce';
                if(!check.checkStr(vm.$v.tmpShipSchedule, '発送日数')) throw 'shipSchedule';

                for(var i =0; i<vm.rCategoryList.child.length; i++){
                    if(!check.checkStr(vm.$v.rCategoryList.child.$each[i].parentId, 'カテゴリ')) throw 'rcategory';
                }
                if(!check.checkStr(vm.$v.rakuma_post_item.R_SHIPMETHOD, '配送方法')) throw 'rShipMethod';
                if(vm.RSizeList.length > 0){
                    if(!check.checkStr(vm.$v.rakuma_post_item.R_SIZE, 'サイズ')) throw 'rSize';
                }
            }catch(e){
                vm.$scrollTo(`#${e}`, {duration:1000,offset: -100})
                return false;
            }
            return true;
        },
        setCategory(){
            let vm = this;
            var category ='';
            for(var i=0; i< eval(`vm.rCategoryList.child.length`); i++){
                if(!eval(`vm.rCategoryList.child[${i}].parentId`)) continue;
                category += eval(`vm.rCategoryList.child[${i}].parentId`) + ',';
            }
            eval(`vm.rakuma_post_item.R_CATEGORY = '${category}'`);
        },
        /**
         * 共通画像設定をEntityにセットする
         */
        async setBase64(){
            let vm = this;
            for(var i=1; i<= 10; i++){
                if(!vm.tmpFiles[i-1]){
                    eval(`vm.postItem.ITEM_IMG${i} = null`);
                }else{
                    var base64 = await vm.resizeImage(vm.tmpFiles[i-1]);
                    eval(`vm.postItem.ITEM_IMG${i} = '${base64}'`);
                }
            }
        },
        /**
         * 共通発送元設定から、各サイト用発送元コードに変換、Entityにセットする
         */
        setShipsource(){
            let vm = this;
            var m = vm.shipsorceList.filter((item)=> {
                return item.CODE_ID == vm.tmpShipsource;
            });
            var r = vm.RShipsorceList.filter((item)=> {
                return item.CODE_NAME == m[0].CODE_NAME;
            });
            // var y = vm.YShipsorceList.filter((item)=> {
            //     return item.CODE_NAME == m[0].CODE_NAME;
            // });
            
            // if(r.length == 0)r[0].CODE_ID = '';
            // if(y.length == 0) y[0].CODE_ID = '48';
            
            vm.postItem.M_SHIPSOURCE = m[0].CODE_ID;
            vm.rakuma_post_item.R_SHIPSOURCE = r[0].CODE_ID;
            // vm.postItem.Y_SHIPSOURCE = y[0].CODE_ID;
        },
        /**
         * 共通発送日程設定から、各サイト用発送日程コードに変換、Entityにセットする
         */
        setShipSchedule(rakuma){
            let vm = this;
            var tmpShipSchedule = {};
            switch(vm.tmpShipSchedule){
                case '1':
                    tmpShipSchedule.m = '1'
                    tmpShipSchedule.tmp = '1'
                    break;
                case '2':
                    tmpShipSchedule.m = '2'
                    tmpShipSchedule.tmp = '2'
                    break;
                case '3':
                    tmpShipSchedule.m = '3'
                    tmpShipSchedule.tmp = '3'
                    break;
            }
            if(rakuma){
                vm.postItem.M_SHIPSCHEDULE = tmpShipSchedule.m;
                vm.rakuma_post_item.R_SHIPSCHEDULE = vm.tmpShipSchedule;
            }else{
                vm.postItem.M_SHIPSCHEDULE = vm.tmpShipSchedule;
                vm.rakuma_post_item.R_SHIPSCHEDULE = tmpShipSchedule.tmp;
                vm.tmpShipSchedule = tmpShipSchedule.tmp;
            }
        },
        /**
         * 共通送料負担設定から、各サイト用送料負担スコードに変換、Entityにセットする
         */
        setShipLoad(rakuma){
            let vm = this;
            var tmpShipLoad = {};
            switch(vm.tmpShipload){
                case '1':
                    tmpShipLoad.m = '1';
                    tmpShipLoad.tmp = '2';
                    break;
                case '2':
                    tmpShipLoad.m = '2';
                    tmpShipLoad.tmp = '1'
                    break;
            }
            if(rakuma){
                vm.postItem.M_SHIPLOAD = tmpShipLoad.m;
                vm.rakuma_post_item.R_SHIPLOAD = vm.tmpShipload;
            }else{
                vm.postItem.M_SHIPLOAD = vm.tmpShipload;
                vm.rakuma_post_item.R_SHIPLOAD = tmpShipLoad.tmp;
                vm.tmpShipload = tmpShipLoad.tmp;
            }
            
            // vm.postItem.Y_SHIPLOAD = tmpShipLoad.y;            
        },
        /**
         * 共通ステータス設定から、各サイト用ステータスコードに変換、Entityにセットする
         */
        setStatus(rakuma){
            let vm = this;
            vm.tmpStatus = vm.tmpStatus.toString();
            var tmpStatus = {};
            console.log(rakuma);
            switch(vm.tmpStatus){
                case '1':
                    tmpStatus.m = '1'
                    tmpStatus.tmp = '6'
                    break;
                case '2':
                    tmpStatus.m = '2'
                    tmpStatus.tmp = '5'
                    break;
                case '3':
                    tmpStatus.m = '3'
                    tmpStatus.tmp = '4'
                    break;
                case '4':
                    tmpStatus.m = '4'
                    tmpStatus.tmp = '3'
                    break;
                case '5':
                    tmpStatus.m = '5'
                    tmpStatus.tmp = '2'
                    break;
                case '6':
                    tmpStatus.m = '6'
                    tmpStatus.tmp = '1'
                    break;
            }
            
            if(rakuma){
                vm.postItem.M_STATUS = tmpStatus.m;
                vm.rakuma_post_item.R_STATUS = vm.tmpStatus;
            }else{
                vm.postItem.M_STATUS = vm.tmpStatus;
                vm.rakuma_post_item.R_STATUS = tmpStatus.tmp;
                vm.tmpStatus = tmpStatus.tmp;
            }
        },
        /**
         * 初期表示値を設定します。
         */
        init(){
            let vm = this;
            vm.ITEM_ID = vm.$route.params.id;
            if(vm.ITEM_ID != 0){
                var userInfo = vm.$functions.getSStorage('userInfo');
                var itemId = `${userInfo.USER_ID}_${vm.ITEM_ID}`;
                
                itemRepository.methods.getOne(itemId)
                .then(res=>{
                    vm.postItem = res.data[0];
                    for(var i=1; i<= 10; i++){
                        if(eval(`vm.postItem.ITEM_IMG${i}`)){
                            vm.tmpFiles.push(eval(`vm.postItem.ITEM_IMG${i}`));
                        }
                    }
                    if(vm.postItem.ROOP_IMG != null) vm.tmpRoopImg = vm.postItem.ROOP_IMG.split(',').filter(Boolean);
                    var index = vm.tmpRoopImg.indexOf('0');
                    if(index != -1){
                        vm.tmpRoopImg.splice(index, 1)
                    }
                    if(vm.tmpRoopImg.length > 0){
                        vm.tmpRoopImg = this.tmpRoopImg.filter((element, index) => this.tmpRoopImg.indexOf(element) == index).sort();
                    }
                    
                }).catch(err=>{
                    console.log(err);
                });
                item_detail_repository.get(itemId).then(res=>{
                    if(res.data.length > 0){
                        vm.rakuma_post_item = res.data[0];

                        if(vm.rakuma_post_item.R_CATEGORY != null){
                            var rCategorys = vm.rakuma_post_item.R_CATEGORY.split(',');
                            for(var i=0; i< rCategorys.length-1; i++){
                                vm.rCategoryList.child[i].parentId = rCategorys[i];
                                vm.getChildCategory('rCategoryList',i);
                                if(i == rCategorys.length-2) vm.RakumaSizeCheck(vm.rCategoryList.child[i].parentId, vm.rCategoryList.child[i]);
                            }
                        }
                        vm.tmpShipsource = vm.rakuma_post_item.R_SHIPSOURCE;
                        vm.tmpShipSchedule = vm.rakuma_post_item.R_SHIPSCHEDULE;
                        vm.tmpShipload = vm.rakuma_post_item.R_SHIPLOAD;
                        vm.tmpStatus = vm.rakuma_post_item.R_STATUS;
                    }
                    
                })
            }
        },
        /**
         * エラーアラートを表示します
         * @param {string}} msg エラーアラートに表示するメッセージ
         */
        ngAlert(msg){
            this.$swal(
                '',
                msg,
                'error'
            )
        }
    },
    created:function(){
        let vm = this;
        code_repository.get()
        .then((data)=>{
            vm.baseCode = data.data;
            //商品状態選択リスト
            vm.statusList           = vm.GetCode("status");
            vm.shiploadList         = vm.GetCode("shipLoad");
            vm.shipsorceList        = vm.GetCode("shipSource");
            vm.shipScheduleList     = vm.GetCode("shipSchedule");
            vm.RSizeListBase            = vm.GetCode("size");
            vm.RShipMethodList      = vm.GetCode("shipMethod");
            vm.RShipsorceList       = vm.GetCode("shipSource");
            vm.RequestRequiredList  = vm.GetCode( "requestRequired");
        });
        
        category_repository.get()
        .then((data)=>{
            vm.baseCategories = data.data;
            vm.rCategoryList.child[0].parent = vm.GetCategories("0");
            vm.init();
        });
    },
    validations: {
        //商品状態
        tmpStatus:{
            required
        },
        //送料負担
        tmpShipload:{
            required
        },
        //発送元
        tmpShipsource:{
            required
        },
        //発送日数
        tmpShipSchedule:{
            required
        },
        mCategoryList:{
            child:{
                $each:{
                    parentId:{
                        required
                    }
                }
            }
        },
        rCategoryList:{
            child:{
                $each:{
                    parentId:{
                        required
                    }
                }
            }
        },
        yCategoryList:{
            child:{
                $each:{
                    parentId:{
                        required
                    }
                }
            }
        },
        postItem:{
            //商品説明
            ITEM_CONTENT:{
                required,
                maxLength:maxLength(1000)
            },
            //商品価格
            ITEM_PRICE:{
                required,
                minValue: minValue(0),
                err:(val)=> check.HankakuSuuzi(val)
            },
            //商品仕入価格
            PURCHASE_PRICE:{
                minValue: minValue(0),
                err:(val)=> check.HankakuSuuzi(val)
            },
            //在庫数
            STOCK_QUANITY:{
                required,
                minValue: minValue(0),
                err:(val)=> check.HankakuSuuzi(val)
            },
            //商品名
            ITEM_TITLE: {
                required,
                maxLength:maxLength(40)
            },
            //商品名2
            ITEM_TITLE2: {
                maxLength:maxLength(40)
            },
            //商品名3
            ITEM_TITLE3: {
                maxLength:maxLength(40)
            },
            //値引額
            DISCOUNT_PRICE:{
                minValue: minValue(0),
                err:(val)=> check.HankakuSuuzi(val)
            },
            //値引き回数
            DISCOUNT_NUM:{
                between:between(0,3),
                err:(val)=> check.HankakuSuuzi(val)
            },
            Y_CATEGORY:{
                required
            },
            Y_QUANTITY:{
                required
            },
            Y_SALESMODE:{
                required
            },
            Y_STARTPRICE:{
                required
            },
            Y_ENDDAY:{
                required
            },
            Y_ENDTIME:{
                required
            },
            Y_CATEGORYORDER:{
                required
            },
            M_CATEGORY:{
                required
            },
            M_SHIPMETHOD:{
                required
            },
            M_SIZE:{
                required
            },
            R_CATEGORY:{
                required
            },
            R_SHIPMETHOD:{
                required
            },
            R_SIZE:{
                required
            }
        },
        rakuma_post_item:{
            R_SIZE:{
                required
            },
            R_SHIPMETHOD:{
                required
            }
        }
    }
}
</script>
<style>
.childImgBox.setImgBox {
    width: 110px;
}
</style>